import type { NavigateFunction } from 'react-router-dom';

export const redirectToSelectedMethod = (provider: number, navigate: NavigateFunction, type: string) =>
  navigate(`/${type}/${provider}`);
